import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {useHistory} from 'react-router-dom';
import {Motion, spring} from 'react-motion';
import CustomerTableRowComponent, {TableCell} from '../components/customer/CustomerTableRowComponent';
import SearchFieldComponent from '../components/common/SearchFieldComponent';
import CustomerNameTableCell from '../components/customer/CustomerNameTableCell';
import {filterCustomers, sortCustomers} from '../utils/customersUtils';
import policiesData from '../data/PoliciesTestData.json';
import Pagination from '../components/common/Pagination';
import TableHeadingComponent from '../components/common/TableHeadingComponent';
import TableRowComponent from '../components/common/TableRowComponent';
import LinkTableCellComponent from '../components/common/LinkTableCellComponent';
import {filterObjectsBy} from '../utils';
import {
    PageWrapper,
    TableWrapper,
    PageContentWrapper,
    PageHeadingWrapper,
    ColumnHeading,
    PaginationWrapper
} from '../styles/PageStyles';
import {fetchPolicesCommand} from '../redux/actions/PoliciesActions';


function FulfillmentPolicies(props) {
    const history = useHistory();
    const {
        company,
        policies,
        fetchCustomers,
        uploadCustomerCsv,
        fetchPolicesCommand
    } = props;

    const [isUploading, setIsUploading] = useState(false);
    const [selectedPolicies, setSelectedPolicies] = useState([]);
    const [query, setQuery] = useState('');

    const [paginationPage, setPaginationPage] = useState(0);
    const [paginationRowsPerPage, setPaginationRowsPerPage] = useState(10);

    const tableHeadings = [
        {
            name: 'Policy ID',
            key: 'policyId',
        },
        {
            name: 'IMEI',
            key: 'imei',
        },
        // {
        //     name: 'Serial Number',
        //     key: 'serialNumber',
        // },
        {
            name: 'Devices',
            key: 'deviceName',
        },
        {
            name: 'Name',
            key: 'name',
        },
        {
            name: 'Company',
            key: 'company',
        }
    ];

    useEffect(() => {
        // fetch policies
        fetchPolicesCommand();
    }, []);

    const handleOnSearchChange = e => {
        setQuery(e.target.value);
    };

    const handleOnCustomerNameClick = () => {
    };

    const handleOnPageChange = page => {
        setPaginationPage(page);
    };

    const handleOnRowsPerPageChange = rowsPerPage => {
        setPaginationRowsPerPage(rowsPerPage);
        setPaginationPage(0);
    };

    const onPolicyCheckboxSelected = (e, policy) => {
        if (selectedPolicies.includes(policy.id)) {
            setSelectedPolicies(selectedPolicies.filter(p => p !== policy.id));
        } else {
            setSelectedPolicies([
                ...selectedPolicies,
                policy.id
            ]);
        }
    };

    /*
     *  Prepare the table cell data to be handed into the table Customers table.
     *
     *  The table cells are custom component. We create the table cell here
     *  so that we can handle any logic attached a table cell outside of the component
     */
    const addTableFieldsToPolicyData = (policyData, selectedPolicies) => policyData.map(policy => {
        const mode = (selectedPolicies.includes(policy.id)) ? 'selected' : (selectedPolicies.length) ? 'disabled' : 'default';
        return {
            ...policy,
            /**
             *  NB - the table cell need to have a key because they are going to used in a list.
             *  NB - the keys for `tableField` should map back to a key from the header data provided.
             */
            tableFields: {
                id: policy.id,
                name: <TableCell key={2}>{policy.repName}</TableCell>,
                company: <TableCell key={2}>{policy.customerName}</TableCell>,
                deviceName: <TableCell key={3}>{policy.deviceName}</TableCell>,
                imei: <TableCell key={4}>{policy.imei}</TableCell>,
                policyId: <LinkTableCellComponent
                    name={policy.policyNumber}
                    onLinkClick={event => event.preventDefault()}
                    key={5}
                />
            }
        };
    });


    // Add table cell components
    const customersWithTableFields = addTableFieldsToPolicyData(policies, selectedPolicies);

    // Apply search filter
    let filteredPolicies = [...customersWithTableFields];
    if (query) filteredPolicies = filterObjectsBy(filteredPolicies, ['name', 'company', 'imei', 'id', 'serialNumber'], query);

    const sortedPolicies = sortCustomers(filteredPolicies);

    const start = paginationPage * paginationRowsPerPage;
    const end = (paginationPage + 1) * paginationRowsPerPage;
    const paginatedPolicesData = sortedPolicies.slice(start, end);

    // Pagination functions and variables
    const paginationCount = filteredPolicies.length;

    console.log('paginated data', paginatedPolicesData);

    return (
        <PageWrapper>

            <PageHeadingWrapper>
                Policies
            </PageHeadingWrapper>

            <div style={{margin: '8px 40px'}}>
                <SearchFieldComponent
                    onSearchChange={handleOnSearchChange}
                    placeholder="Filter by policy ID, IMEI, customer name or company"
                />
            </div>

            {/**
             *  Customers Table
             **/}
            <TableWrapper>
                <TableHeadingComponent hasCheckBox={false} tableHeadings={tableHeadings}/>
                {
                    paginatedPolicesData.map((policy, index) =>
                        // each heading contains customers under that letter heading
                        (
                            <div key={index}>
                                <TableRowComponent
                                    tableHeadings={tableHeadings}
                                    rowData={policy.tableFields}
                                    hasCheckBox={true}
                                    isSelected={selectedPolicies.includes(policy.id)}
                                    onCheckBoxSelected={onPolicyCheckboxSelected}
                                />
                            </div>
                        ))
                }
            </TableWrapper>


            {/**
             * Pagination Section
             **/}
            <Motion
                defaultStyle={{y: 200}}
                style={{y: spring(paginationCount >= 1 ? 0 : 200)}}
            >
                {
                    style => (
                        <PaginationWrapper
                            style={{transform: `translateY(${style.y}px)`, }}
                        >
                            <Pagination
                                count={paginationCount}
                                page={paginationPage}
                                rowsPerPage={paginationRowsPerPage}
                                onChangePage={handleOnPageChange}
                                onRowsPerPageChange={handleOnRowsPerPageChange}
                            />
                        </PaginationWrapper>
                    )
                }
            </Motion>
        </PageWrapper>
    );
}

FulfillmentPolicies.propTypes = {};
FulfillmentPolicies.defaultProps = {};

const mapStateToProps = state => ({policies: state.policies});
const mapDispatchToProps = { fetchPolicesCommand };

export default connect(mapStateToProps, mapDispatchToProps)(FulfillmentPolicies);
